export {LegalNavigationComponent} from './legal-navigation/legal-navigation.component';
export {LegalListComponent} from './legal-list/legal-list.component';
export {LegalInformationComponent} from './legal-information/legal-information.component';
